import { API_CHAIN_MGMT } from 'utils/constants'
import Api from './axiosInstance'

type FetchChainsParams = {
  limit: number
  page: number
  isActive?: boolean
  search?: string
  fileSourceType?: string
}

const fetchChains = ({
  limit,
  page,
  search,
  isActive,
  fileSourceType,
}: FetchChainsParams) => {
  const options: any = {}

  if (search) options.search = search
  if (isActive !== undefined) options.isActive = isActive
  if (fileSourceType) options.fileSourceType = fileSourceType

  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page),
    ...options,
  })

  return Api.get({ url: `${API_CHAIN_MGMT.CHAIN}?${params}` })
}

const fetchChain = (id: string) =>
  Api.get({ url: `${API_CHAIN_MGMT.CHAIN}/${id}` })

const createChain = (data: any) => Api.post({ url: API_CHAIN_MGMT.CHAIN, data })

const updateChain = (id: string, data: any) =>
  Api.patch({ url: `${API_CHAIN_MGMT.CHAIN}/${id}`, data })

const deleteChain = (id: string) =>
  Api.delete({ url: `${API_CHAIN_MGMT.CHAIN}/${id}` })

export { fetchChains, fetchChain, createChain, updateChain, deleteChain }
